import React from "react";

import "../Spinner/Spinner.css";

function Spinner() {
  return (
    <div className="container_spinner">
      <i className="fas fa-circle-notch fa-2x"></i>
    </div>
  );
}

export default Spinner;
